export default "__VITE_ASSET__E2YP8Opl__"